import(/* webpackMode: "eager" */ "/vercel/path0/apps/terminal/app/ningenie/page.tsx");
